import React, { useMemo, useState, useContext } from "react";
import styles from "./index.module.scss";
import useTileScroller from "../../hooks/useTileScroller";
import { Link } from "react-scroll";
import MyDropdown from "./Dropdown";
// import { OPTIONS } from "./Options";
import { isMobileDevice } from "../../utils/getPlatformInfo";
import { useTheme } from "../../contexts/ThemeContext/ThemeContext";
import { useScrollHandler } from "../../hooks/useScroll";
import { AnalyticsContext } from "../../contexts/Analytics/AnalyticsContextProvider";
import { TAG_CLICKED } from "../../AppConstants/AnalyticsEventName";
import { ConstantDataContext } from "../../contexts/ConstantContext/ConstantDataContextProvider";
import { Box, Shimmer } from "../ShimmerEffect";
import { eventSectionId } from "../../AppConstants/Constants";

function TagSection({
  // TAGS = OPTIONS,
  selectedTag,
  showspeciality,
  initalIndex = 0,
  withOutBanner,
}) {
  const { TagsData: TAGS_DATA } = useContext(ConstantDataContext);
  const scrollValue = useScrollHandler(0);
  const { addGAWithUserInfo } = useContext(AnalyticsContext);

  let topReached = false;
  if (withOutBanner) {
    topReached = scrollValue >= (isMobileDevice ? 250 : 90);
  } else {
    topReached = scrollValue >= (isMobileDevice ? 2500 : 5000); //250 : 680
  }

  const { currentIndex, updateIndex } = useTileScroller({
    noOfTiles: 30,
    onEndReached: () => {},
    elementId: "tagSection",
    tileGapWeb: 30,
    autoScrollToCard: false,
    indexing: true,
    allowScroll: false,
    initalIndex: initalIndex,
    webTileId: topReached || isMobileDevice ? "tagCardMob" : "tagCard",
    tileGapMob: 20,
  });

  const [selectedIndex, setSelectedIndex] = useState(0); //13; // to get tags according to speciality index

  selectedTag !== undefined && updateIndex(selectedTag);
  const { isDark } = useTheme();

  const navHeight = !isMobileDevice ? (!showspeciality ? 0 : 120) : 60;

  const tagList = useMemo(() => Object.keys(TAGS_DATA), [TAGS_DATA]);

  const CompactTag = ({ tag, index }) => {
    if (!TAGS_DATA[tag].enable || TAGS_DATA[tag].sectionId === eventSectionId) {
      return <></>;
    }
    return (
      <Link
        disabled={TAGS_DATA[tag].clickable}
        to={TAGS_DATA[tag].sectionId}
        spy={true}
        smooth={true}
        duration={500}
        delay={100}
        offset={-220} //previus -300
        className={`${styles.tagCard} ${styles.tagCardSmall}`}
        id={`tagCardMob${index}`}
        onClick={() => {
          addGAWithUserInfo(TAG_CLICKED, { eventId: TAGS_DATA[tag].label });
          // setLocation(index);
          // updateIndex(index);
        }}
        style={{
          // border: currentIndex === index ? `3px solid #EB4547` : 0,
          height: isMobileDevice ? "2.8rem" : "3.2rem",
          minWidth: isMobileDevice ? "45vw" : "auto",
          overflow: "unset",
          fontSize: isMobileDevice ? "1.2rem" : "1.1rem",
          backgroundColor: isDark ? "#2C4067" : "#2B2B2B",
          borderRadius: "2rem",
          padding: "0.3125rem 1.5625rem",
        }}
      >
        {TAGS_DATA[tag].label}
      </Link>
    );
  };

  return (
    <Shimmer
      loading={tagList.length === 0}
      loadingComponent={
        <div
          style={{
            padding: "0 6%",
          }}
        >
          <div
            style={{
              display: "flex",
              marginTop: 30,
              marginBottom: 10,
            }}
          >
            {isMobileDevice ? (
              <>
                {" "}
                <Box height={90} width={350} marginRight={10} />
                <Box height={90} width={350} marginRight={10} />
              </>
            ) : (
              <>
                {" "}
                <Box height={90} width={200} marginRight={30} />
                <Box height={90} width={200} marginRight={30} />
                <Box height={90} width={200} marginRight={30} />
                <Box height={90} width={200} marginRight={30} />
                <Box height={90} width={200} marginRight={30} />
              </>
            )}
          </div>
        </div>
      }
      renderComponent={
        <>
          {showspeciality && (
            <MyDropdown
              selectedIndex={selectedIndex}
              onSelect={setSelectedIndex}
              topReached={topReached}
              openTitle="Specialities"
            />
          )}
          <div
            className={styles.tagsWrapper}
            id="tagSection"
            style={{
              // backgroundColor: topReached ? "#0A2347" : "transparent",
              boxShadow: topReached
                ? "0px 6px 12px rgba(0, 0, 0, 0.25)"
                : "none",
              // paddingBottom: "1.25rem",
              top: navHeight,
            }}
          >
            {/* {TAGS[selectedIndex].tags.map((tag, index) => { */}
            {/* {tagList.map((tag, index) => 
           (
            // <CompactTag tag={tag} index={index} key={index} />
            <CompactTag key={index} tag={tag} index={index} />
          ))
        } */}
            {tagList.map((tag, index) => {
              return topReached || isMobileDevice ? (
                <CompactTag key={index} tag={tag} index={index} />
              ) : (
                <React.Fragment key={index}>
                  {TAGS_DATA[tag].enable &&
                    TAGS_DATA[tag].sectionId !== eventSectionId && (
                      <Link
                        disabled={TAGS_DATA[tag].clickable}
                        to={TAGS_DATA[tag].sectionId}
                        spy={true}
                        smooth={true}
                        duration={500}
                        delay={100}
                        offset={-300}
                        key={index}
                        className={`${styles.tagCard} ${
                          topReached ? styles.tagCardSmall : null
                        }`}
                        id={`tagCard${index}`}
                        onClick={() => {
                          addGAWithUserInfo(TAG_CLICKED, {
                            eventId: TAGS_DATA[tag].label,
                          });
                          // setLocation(index);
                          // updateIndex(index);
                        }}
                        style={{
                          // border: currentIndex === index ? `3px solid #EB4547` : 0,
                          outlineOffset: `4px`,
                          height: topReached ? "2.6875rem" : "7.125rem",
                          minWidth: topReached ? "auto" : "16.625rem",
                          fontSize: topReached ? "1.2rem" : "1.6rem",
                          backgroundColor: !topReached
                            ? "transparent"
                            : isDark
                            ? "#2C4067"
                            : "#fff",
                          borderRadius: !topReached ? "1rem" : "2rem",
                          padding: topReached ? "0.3125rem 1.5625rem" : "0",
                          color: "#fff",
                        }}
                      >
                        {!topReached ? (
                          <img
                            src={TAGS_DATA[tag].icon}
                            alt={tag.name}
                            className={styles.bgImg}
                            style={!isDark ? { filter: "brightness(0.5)" } : {}}
                          />
                        ) : null}
                        {TAGS_DATA[tag].label}
                      </Link>
                    )}
                </React.Fragment>
              );
            })}
          </div>
        </>
      }
    />
  );
}

export default TagSection;
